import BaseService from "./geral/BaseService";

const base = "DirecionamentoTecon";

export default class DirecionamentoTeconService extends BaseService {
    constructor() {
        super(base);
    }

    
    Operacoes(dataInicial, dataFinal, tipoDoc) {
        return super.httpGet(`/${base}/Operacoes?dataInicial=${dataInicial}&dataFinal=${dataFinal}&tipoDocumento=${tipoDoc}`);
        
    }

    Status() {
        return super.httpGet(`/${base}/ListaStatus`)
    }
    
    //TECON
    
    TeconConsultar(direcionamentoTeconId="", operacao="", status="", ceHouse="", container="", cnpj="", cliente="", navioAssoc) {
        //return super.httpGet(`/${base}/ConsultaDirecionamentoTecon?direcionamentoTeconId=&operacao=BD1045N&status=&ceHouse=101805257710738&container=&cnpj=&cliente=`);
        //Demora demais isso daqui
        return super.httpGet(`/${base}/ConsultaDirecionamentoTecon?direcionamentoTeconId=${direcionamentoTeconId}&operacao=${operacao}&status=${status}&ceHouse=${ceHouse}&container=${container}&cnpj=${cnpj}&cliente=${cliente}&semNavioAssoc=${navioAssoc}`);
    }
    TeconCarregarOutrosDados(teconId="") {
        return super.httpGet(`/${base}/CarregaTecon/${teconId}`)
    }
    TeconDownloadDocumento(teconId="") {
        return super.httpGet(`/${base}/DownloadDocumentoTecon/${teconId}`)
    }
    TeconInativar(inativados=[]) {
        return super.httpPost(`/${base}/InativaTecon/`, inativados)
    }
    TeconInclusao(ceHouse="",email="",codeRef="",arq) {
        return super.httpPost(`/${base}/InclusaoTecon?CeHouse=${ceHouse}&Email=${email}&CodRef=${codeRef}`,arq)
    }
    TeconEditar(obj) {
        return super.httpPost(`/${base}/EditaTecon`, obj)
    }
    TeconImportarXls(arquivoXls) {
        return super.httpPost(`/${base}/TransformarXlsEmTecon`,arquivoXls)
    }
    TeconOperacoes() {
        return super.httpGet(`/${base}/OperacoesTecon`)
    }

}


// WEBPACK FOOTER //
// ./src/services/DirecionamentoTeconService.js